import { useEffect } from "react"
import HCRender from "aldoo-ra/HelpCenter/hc-render"
import { getPublishedCategories } from "aldoo-ra/HelpCenter/categoryUtils"

const HelpCenterBrowser = ({
  rootCategoriesData = null,
  onArticleSelect,
  onCategorySelect,
  currentPath = {},
  expandedCategories = {},
}) => {
  const BrowserCategory = HCRender.getFragment("BrowserCategory")

  useEffect(() => {
    const isPathEmpty =
      !currentPath.type &&
      !currentPath.slug &&
      !currentPath.categoryPath &&
      !currentPath.exactPath &&
      !currentPath.directParentPath

    if (
      isPathEmpty &&
      expandedCategories &&
      Object.keys(expandedCategories).length > 0
    ) {
      onCategorySelect && onCategorySelect(null, true)
    }
  }, [currentPath, expandedCategories, onCategorySelect])

  const categoriesToRender = getPublishedCategories(rootCategoriesData)
  if (categoriesToRender.length === 0) return null

  if (!BrowserCategory) return null

  return (
    <div>
      {categoriesToRender.map((category) => (
        <BrowserCategory
          key={category._id}
          category={category}
          onArticleSelect={onArticleSelect}
          onCategorySelect={onCategorySelect}
          expandedCategories={expandedCategories}
          currentPath={currentPath}
          fullPath=""
          preloadedData={true}
        />
      ))}
    </div>
  )
}

export default HelpCenterBrowser
